import type { ExtractedLeadV2 } from "@/types/lead";
import { preferNonEmpty } from "@/lib/lead/extraction/textHeuristics";

export function mergeExtractedPreferNonEmpty(
  newer?: ExtractedLeadV2 | null,
  older?: ExtractedLeadV2 | null,
): ExtractedLeadV2 | null {
  if (!newer && !older) return null;

  const n = newer || ({} as ExtractedLeadV2);
  const o = older || ({} as ExtractedLeadV2);

  return {
    ...o,
    ...n,

    first_name: preferNonEmpty(n.first_name, o.first_name),
    last_name: preferNonEmpty(n.last_name, o.last_name),
    phone: preferNonEmpty(n.phone, o.phone),
    email: preferNonEmpty(n.email, o.email),

    interest_level: preferNonEmpty(n.interest_level, o.interest_level),
    ready_to_buy_timeline: preferNonEmpty(n.ready_to_buy_timeline, o.ready_to_buy_timeline),

    product_line: preferNonEmpty(n.product_line, o.product_line),
    product_subtype: preferNonEmpty(n.product_subtype, o.product_subtype),
    size_config: preferNonEmpty(n.size_config, o.size_config),
    size_options: preferNonEmpty(n.size_options, o.size_options),
    product_interest_category: preferNonEmpty(n.product_interest_category, o.product_interest_category),
    enunciated_budget: preferNonEmpty(n.enunciated_budget, o.enunciated_budget),

    lead_source_category: preferNonEmpty(n.lead_source_category, o.lead_source_category),
    lead_source_detail: preferNonEmpty(n.lead_source_detail, o.lead_source_detail),

    customer_city_state: preferNonEmpty(n.customer_city_state, o.customer_city_state),

    install_address_full: preferNonEmpty(n.install_address_full, o.install_address_full),
    install_address_street: preferNonEmpty(n.install_address_street, o.install_address_street),
    install_address_city: preferNonEmpty(n.install_address_city, o.install_address_city),
    install_address_state: preferNonEmpty(n.install_address_state, o.install_address_state),
    install_address_postal_code: preferNonEmpty(n.install_address_postal_code, o.install_address_postal_code),

    billing_address: preferNonEmpty(n.billing_address, o.billing_address),

    distance_from_lot_miles: preferNonEmpty(n.distance_from_lot_miles, o.distance_from_lot_miles),
    distance_from_plant_miles: preferNonEmpty(n.distance_from_plant_miles, o.distance_from_plant_miles),
    nearest_steel_plant_name: preferNonEmpty(n.nearest_steel_plant_name, o.nearest_steel_plant_name),
    nearest_steel_plant_distance_miles: preferNonEmpty(
      n.nearest_steel_plant_distance_miles,
      o.nearest_steel_plant_distance_miles,
    ),

    interest_tags: preferNonEmpty(n.interest_tags, o.interest_tags),

    notes: [n.notes, o.notes]
      .filter((v) => typeof v === "string" && v.trim())
      .join("\n\n--- merged notes ---\n\n"),
  };
}
